// src/pages/HRPayroll/salaryPaymentSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSalaryPayments,
  fetchSalaryPaymentCode,
  saveSalaryPayment,
  deleteSalaryPayment,
} from "./salaryPaymentThunk";
import { currentDateTime } from "../../lib/functions";

const initialState = {
  paymentDate: currentDateTime(),
  list: [],
  paymentCode: "",
  loading: false,
  error: null,
  selectedSalaryPayment: null,
  isEditSalary: false,
  refreshList: false,
};

const salaryPaymentSlice = createSlice({
  name: "salaryPayments",
  initialState,
  reducers: {
    resetSalaryPayments: () => initialState,
    setPaymentCode: (state, action) => {
      state.paymentCode = action.payload;
    },
    setPaymentDate(state, action) {
      state.paymentDate = action.payload;
    },
    setSelectedSalaryPayment(state, action) {
      state.selectedSalaryPayment = action.payload;
    },
    setIsEditSalary(state, action) {
      state.isEditSalary = action.payload;
    },
    setRefreshList(state, action) {
      state.refreshList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSalaryPayments.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSalaryPayments.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchSalaryPayments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchSalaryPaymentCode.fulfilled, (state, action) => {
        state.paymentCode = action.payload;
      })
      .addCase(saveSalaryPayment.fulfilled, (state) => {
        state.refreshList = true;
      })
      .addCase(deleteSalaryPayment.fulfilled, (state, action) => {
        state.list = state.list.filter((e) => e.pay_id !== action.payload.id);
      });
  },
});

export const {
  resetSalaryPayments,
  setPaymentCode,
  setPaymentDate,
  setSelectedSalaryPayment,
  setIsEditSalary,
  setRefreshList,
} = salaryPaymentSlice.actions;

export default salaryPaymentSlice.reducer;
